import React from "react";
import PropertyFaqList from "../faq/PropertyFaqList";
const PropertyFaq = ({ faq }) => {
  return (
    <div className="faq-section mt-4 mb-4" id="faq-section">
      <h1 className="desc-title">Frequently Asked Questions</h1>
      {faq.map((faq, index) => (
        <PropertyFaqList
          key={index}
          question={faq.question}
          answer={faq.answer}
        />
      ))}
    </div>
  );
};

export default PropertyFaq;
